export default __webpack_public_path__ + "static/media/pullQuote2Erika.f0aae0dc.wav";